<style lang="less" scoped>
    .w {
        width: 1200px;
        min-height: calc(100vh - 200px);
        margin: 0 auto;
        padding-bottom: 50px;
        box-sizing: border-box;
        justify-content: space-between;
    }

    /*.plan_tabs {*/
    /*margin-top: 60px;*/
    /*display: flex;*/
    /*// justify-content: space-between;*/
    /*flex-wrap: wrap;*/
    /*// overflow-x: scroll;*/
    /*background-color: rgba(13, 140, 255, 0.76);*/
    /*overflow: auto;*/
    /*.tabsitem {*/

    /*div:nth-child(1) {*/
    /*width: auto;*/
    /*padding: 0 21px;*/
    /*float: left;*/
    /*height: 48px;*/
    /*font-size: 16px;*/
    /*color: #f8f3e8;*/
    /*text-align: center;*/
    /*line-height: 48px;*/
    /*border-right-width: 1px;*/
    /*border-right-style: solid;*/
    /*border-right-color: #f87400;*/
    /*-webkit-box-sizing: border-box;*/
    /*-moz-box-sizing: border-box;*/
    /*box-sizing: border-box;*/
    /*}*/
    /*div:nth-child(2) {*/
    /*font-size: 14px;*/
    /*color: #666666;*/
    /*text-align: center;*/
    /*margin-top: 5px;*/
    /*}*/
    /*}*/
    /*.tabsitem:nth-child(5n) {*/
    /*margin-right: 0;*/
    /*}*/
    /*}*/
    .active {
        background-color: #f25412; //#6fc4f8;
        color: #fff !important;
    }

    .active2 {
        color: #ff6e39;
        border-radius: 6px;
        background-color: rgba(255, 149, 17, 0.2);
    }

    .active3 {
        background-color: #f85415;
        color: #fff !important;
    }

    .current2 {
        background-color: #e67300;
        color: #fff !important;
    }

    .info1 {
        margin-top: 15px;
        margin-left: 20px;
        .title1 {
            font-size: 18px;
            font-weight: 500;
            color: #333333;
        }

        .rests1 {
            margin-top: 20px;
            font-size: 12px;
            color: #999999;
            div {
                margin-right: 35px;
            }
        }
    }

    .right1 {
        margin-right: 20px;
        .btn1 {
            margin-left: 50px;
            margin-top: 45px;
            margin-bottom: 15px;
            text-align: center;
            width: 100px;
            height: 36px;
            line-height: 36px;
            border: 1px solid #ff551b;
            border-radius: 18px;
            color: #ff551b;
        }

    }

    .tiku_top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 90px;
        background-color: #ff9511;
        margin: 30px 0 20px 0;
        /*padding: 25px;*/
        /*box-sizing: border-box;*/
        .top_left {
            display: flex;
            .top_tit {
                font-size: 20px;
                font-weight: 600;
            }
            .top_change {
                width: 110px;
                height: 30px;
                background: #0090f0;
                border-radius: 15px;
                font-size: 14px;
                color: #fff;
                text-align: center;
                line-height: 30px;
                margin-left: 25px;
                cursor: pointer;
            }
        }
        .top_right {
            width: 142px;
            height: 30px;
            border: 1px solid rgba(0, 144, 240, 0.2);
            color: #0090f0;
            border-radius: 15px;
            font-size: 14px;
            text-align: center;
            line-height: 30px;
            cursor: pointer;
            img {
                width: 18px;
                height: 20px;
                vertical-align: middle;
            }
        }
    }

    .box {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        > div {
            width: 49%;
            height: 216px;
            background-color: #ff6e39;
            color: #fff;
            text-align: center;
        }
    }

    .tiku_tabs {
        padding-top: 70px;
        width: 100%;
        background-color: #fff;
        margin: 20px 0;
        font-size: 16px;
        /*border-radius: 6px;*/

        .tabs_top {
            overflow: auto;
            display: flex;
            align-items: center;
            width: 100%;
            height: 48px;
            border-radius: 10px;
            /*border-bottom: 1px solid #ff551b;*/
            background-color: #ff6829; //rgba(13, 140, 255, 0.76);
            .tabs_item {
                div:nth-child(1) {
                    width: auto;
                    padding: 0 21px;
                    float: left;
                    height: 48px;
                    font-size: 16px;
                    color: #f9f2f2;
                    text-align: center;
                    line-height: 48px;
                    border-right-width: 1px;
                    border-right-style: solid;
                    border-right-color: orange;
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                }

                /*width: 80px;
                height: 100%;
                border-right: 1px solid #ff551b;
                text-align: center;
                cursor: pointer;
                img {
                    width: 30px;
                    height: 30px;
                    margin-bottom: 10px;
                    margin-top: 30px;
                }*/
            }
        }
        .selects {
            type: flex;
            margin-left: 680px;
            .el-select {
                border-radius: 30px;
            }
        }
        .kemu {
            display: flex;
            // align-items: center;
            width: 100%;
            // height: 67px;
            padding: 15px 25px;
            padding-bottom: 5px;
            box-sizing: border-box;
            span {

                margin-top: 5px;
            }
            .kemu_rt {
                display: flex;
                flex-wrap: wrap;
                width: 95%;
                .kemu_item {
                    // margin: 0 10px;
                    margin-right: 10px;
                    padding: 8px 20px;
                    box-sizing: border-box;
                    cursor: pointer;
                    margin-bottom: 10px;

                }

            }

        }
        .info {
            margin-top: 15px;
            margin-left: 20px;
            .title {
                font-size: 18px;
                font-weight: 500;
                color: #333333;
            }

            .rests {
                margin-top: 20px;
                font-size: 12px;
                color: #999999;
                div {
                    margin-right: 35px;
                }
            }
        }
        .right {
            margin-right: 20px;
            .list_btn {
                margin-top: 5px;
                width: 80px;
                height: 28px;
                border: 1px solid #ff551b;
                background: #02cb73;
                border-radius: 14px;
                text-align: center;
                line-height: 28px;
                color: #fff;
                font-size: 12px;
                cursor: pointer;
            }
            .list_btn2 {
                margin-top: 5px;
                width: 80px;
                height: 28px;
                border: 1px solid #ff551b;
                border-radius: 14px;
                text-align: center;
                line-height: 28px;
                color: #ff551b;
                font-size: 12px;
                cursor: pointer;
            }
            .list_btn_n {
                background: #999;
            }
            .list_btn_n1 {
                background: #cccccc;
            }
            .btn {
                margin-left: 50px;
                margin-top: 45px;
                margin-bottom: 15px;
                text-align: center;
                width: 100px;
                height: 36px;
                line-height: 36px;
                border: 1px solid #ff551b;
                border-radius: 18px;
                color: #ff551b;
            }
            .btn_b {
              background: #999;
              color: #fff;
            }

          .btn1 {
            background-color: #f8f8f5;
            color: #a49173;
            border: 1px solid #aeaba9;
          }
            .look {
                font-weight: bold;
                color: #666666;
            }
        }

    }
</style>
<template>
    <div>
        <el-dialog :visible.sync="daiShow" width="80%" :show-close="false">
            <div v-for="(item,index) in recordList" :key="index" v-if="recordList.length > 0">
                <div style="cursor: pointer;
    margin: 0 30px;
    height: 118px;
    border-bottom: 2px solid #f2f2f2;
    justify-content: space-between; display: flex">

                    <div class="info1">
                        <div class="title1">
                            {{item.title}}
                        </div>
                        <div class="flex rests1">
                            <div>题目数量：{{ item.examTotleNum }}道</div>
                            <div>正确题数：{{ item.examNum }}道</div>
                        </div>
                    </div>
                    <div class="flex1 right1">
                        <div class="btn1"
                             @click="analysiss(item.examId,item.id)"
                             :class="{ active3: active3== item.id }"
                             @mouseenter="active3 = item.id"
                             @mouseleave="active3 = -1">查看解析
                        </div>
                    </div>
                </div>

            </div>
            <div v-if="recordList==0" style="text-align: center"> {{"暂无做题记录"}}</div>
        </el-dialog>

        <div class="w">

            <div class="tiku_tabs">
                <div class="tabs_top">
                    <div
                            class="tabs_item"
                            v-for="(item, index) in tabsList"
                            :key="index"
                            :class="{ active: active == index }"
                            @click="tabsChange(index)"
                    >
                        <div>{{ item }}</div>
                    </div>
                    <div class="selects">
                        <el-select v-model="name" placeholder="选择学期" @change="changeTabs">
                            <el-option
                                    v-for="(item,index) in semesterList"
                                    :key="index"
                                    :label="item.name"
                                    :value="index">
                            </el-option>
                        </el-select>


                    </div>
                </div>
                <div class="kemu">
                    <span>课程：</span>
                    <div class="kemu_rt">
                        <div
                                class="kemu_item"
                                v-for="(item1, index1) in course"
                                :key="index1"
                                :class="{ active2: active2 == item1.id }"
                                @click="tabsChange2(active, item1.id)"
                        >

                            {{ item1.name }}

                        </div>

                    </div>
                </div>
<!--课堂练习-->
                <div v-for="(item2,index2) in listData" v-if="active==0">
                    <div style="cursor: pointer;
    margin: 0 30px;
    height: 118px;
    border-bottom: 2px solid #f2f2f2;
    justify-content: space-between; display: flex">

                        <div class="info">
                            <div class="title">
                                {{item2.examName}}
                            </div>
                            <div class="flex rests">
                                <div>考试时长：{{ item2.allTime }}分钟</div>
                                <div>剩余考试次数：{{item2.remainingNum}}</div>
                                <div>历史最高分：{{item2.maxScore}}</div>
                            </div>
                            <div v-if="item2.remainingNum<=0">
                              <span style="color: red">练习次数已经用完</span>
                            </div>
                        </div>
                        <div class="flex1 right">
                          <div v-if="item2.remainingNum<=0" class="btn btn1">
                            无权限
                          </div>

                          <div v-else-if="new Date().getTime() >= end_time && end_time != 0"
                               class="btn btn_b">
                            已结束
                          </div>
                          <div v-else-if="new Date().getTime() < start_time && start_time != 0"
                               class="btn btn_b">
                            未开始
                          </div>

                            <div v-else class="btn"
                                 @click="exam(item2.id)"
                                 :class="{ current2: current2 == index2 }"
                                 @mouseenter="current2 = index2"
                                 @mouseleave="current2 = -1">开始练习
                            </div>


                        </div>
                    </div>

                </div>

<!--考试-->
                <div v-for="(item2,index2) in listData1" v-if="active==1">
                    <div style="cursor: pointer;
    margin: 0 30px;
    height: 118px;
    border-bottom: 2px solid #f2f2f2;
    justify-content: space-between; display: flex">

                        <div class="info">
                            <div class="title">
                                {{item2.examName}}
                            </div>
                            <div class="flex rests">
                                <div>考试时长：{{ item2.allTime }}分钟</div>
                                <div>剩余考试次数：{{item2.remainingNum}}</div>
                                <div>历史最高分：{{item2.maxScore}}</div>
                            </div>
                            <div v-if="item2.remainingNum<=0">
                              <span style="color: red">考试次数已经用完</span>
                            </div>
                        </div>
                        <div class="flex1 right">
                            <div v-if="item2.remainingNum<=0" class="btn btn1">
                              无权限
                            </div>
                            <div v-else-if="new Date().getTime() >= end_time && end_time != 0"
                                 class="btn btn_b">
                                已结束
                            </div>
                            <div v-else-if="new Date().getTime() < start_time && start_time != 0"
                                 class="btn btn_b">
                                未开始
                            </div>

                            <div
                                v-else-if="item2.is_pass == 1 && item2.btn == 1"
                                    class="list_btn"
                            >
                                已通过
                            </div>
<!--                            <div v-if="item2.remainingNum<=0 || (item2.eeTime * 1000  <= new Date().getTime()) || (item2.ssTime * 1000  >= new Date().getTime())"-->
<!--                                 class="btn btn1">-->
<!--                              无权限-->
<!--                            </div>-->
                            <div
                                v-else-if="item2.remainingNum>0 && (item2.ssTime * 1000 <= new Date().getTime()) && (new Date().getTime() <= item2.eeTime * 1000)"
                                    class="btn" @click="exam(item2.id)"
                                    :class="{ current2: current2 == index2 }"
                                    @mouseenter="current2 = index2"
                                    @mouseleave="current2 = -1">开始考试
                            </div>
                        </div>
                    </div>

                </div>
<!--答题记录-->
                <div v-for="(item2,index2) in listData2" v-if="active==2">
                    <div style="cursor: pointer;
    margin: 0 30px;
    height: 118px;
    border-bottom: 2px solid #f2f2f2;
    justify-content: space-between; display: flex">

                        <div class="info">
                            <div class="title">
                                {{item2.examName}}
                            </div>
                            <div class="flex rests">
                                <div>考试时长：{{ item2.allTime }}分钟</div>
                                <div>剩余考试次数：{{item2.remainingNum}}</div>
                                <div>历史最高分：{{item2.maxScore}}</div>
                            </div>
                        </div>
                        <div class="flex1 right">
                            <div class="btn" @click="record(item2.id)"
                                 :class="{ current2: current2 == index2 }"
                                 @mouseenter="current2 = index2"
                                 @mouseleave="current2 = -1">做题记录
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>
<script>


    import {
        studyIndex, courseExercises, makeNotes, makeExams
    } from "../../assets/js/api";

    export default {

        data() {
            return {
                zhangFlag: false,
                siteId: window.localStorage.getItem("siteId"),
                user_id: localStorage.getItem("info"),
                title: {
                    name: "",
                },
                name: "",
                his: false,
                daiShow: false,
                active: 0,
                active2: 0,
                active3: "",
                current2: 0,
                changeType: "",
                dailogList: [],
                tabsList: ["课堂练习", "考试", "答题记录"],
                // tabsList: ["课堂练习", "考试"],
                kemuList: [],
                listData: [],
                listData1: [],
                listData2: [],
                semester: [],
                course: [],
                exercise: [],
                start_time: "",
                end_time: "",
                tips: "",
                // 教学计划
                semesterList: "",
                recordList: [],
                nowIndex: 0

            };
        },
        created() {
            this.studyData()
        },

        methods: {
            studyData() {
                studyIndex(window.localStorage.getItem("siteId"), window.localStorage.getItem("info")).then((res) => {
                    if (res.code == 200) {
                        let i = 0;
                        console.log("添加" + JSON.stringify(res.data.terms))
                        this.semesterList = res.data.terms;
                        console.log(i, "index")
                        /*this.start_time = res.data.terms[i].beginTime;
                        this.end_time = res.data.terms[i].endTime;
                        this.course = res.data.terms[i].myClasss;*/

                        this.active = i;
                      console.log("a")
                      this.semester = res.data.terms[0];
                      console.log("a1")
                        this.start_time = res.data.terms[0].beginTime * 1000;
                        this.end_time = res.data.terms[0].endTime * 1000;
                        this.course = res.data.terms[0].myClasss;
                        this.tips = res.data.terms[0].tips;
                        this.name = res.data.terms[0].name;
                        this.active2 = res.data.terms[0].myClasss[0].id;

                        res.data.terms.forEach((item, index) => {
                            if (item.have_in_hand == 1) {
                                this.active = i;
                                this.semester = res.data.terms[index];
                                this.start_time = res.data.terms[index].beginTime * 1000;
                                this.end_time = res.data.terms[index].endTime * 1000;
                                this.course = res.data.terms[index].myClasss;
                                this.tips = res.data.terms[index].tips;
                                this.name = item.name;
                                this.active2 = res.data.terms[index].myClasss[0].id;
                            }
                        });
                      courseExercises(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), 3, this.course[0].id).then((ress) => {

                        this.listData = ress.data;
                      });
                      courseExercises(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), 1, this.course[0].id).then((resss) => {
                        this.listData1 = resss.data;
                      });
                      courseExercises(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), -1, this.course[0].id).then((ressss) => {
                        this.listData2 = ressss.data;
                      });

                    } else {
                        this.$message.warning(res.msg);
                    }
                });
            },

            changeTabs(i) {
                console.log(i, " 切换")
                this.active2 = i;
                this.nowIndex = i;
                this.start_time = this.semesterList[i].beginTime * 1000;
                this.end_time = this.semesterList[i].endTime * 1000;
                this.course = this.semesterList[i].myClasss;
                this.listData = []
                this.listData1 = []
                this.listData2 = []
              console.log("s="+this.start_time)
              console.log("e="+this.end_time)
                courseExercises(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), 3, this.course[0].id).then((ress) => {
                    this.listData = ress.data;
                    console.log(ress.data, "课堂练习")
                });
                courseExercises(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), 1, this.course[0].id).then((resss) => {
                    this.listData1 = resss.data;
                    console.log(resss.data)
                });
                courseExercises(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), -1, this.course[0].id).then((ressss) => {
                    this.listData2 = ressss.data;
                });

            },
            // 跳转到补考
            toMakeUpExam() {
                courseExercises(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), 2, id).then((res) => {
                    res.data.forEach((item) => {
                        item.flag = false;
                        item.recordList = [];
                    });
                    this.exercise = res.data;
                });
            },
// 点击确定 进入试卷页面
            exam(id) {
                this.$router.push({path: "/exam", query: {c_e_id: id}});
            },

            //跳转至错题解析
            analysis(id) {
                this.$router.push({path: "/analysis", query: {"examId": this.c_e_id, id: id}});
            },

            analysiss(examId, id) {
                this.$router.push({path: "/analysis", query: {"examId": examId, examDoId: id}});
            },


            //答题记录
            record(id) {
                this.daiShow = true
                makeNotes(localStorage.getItem("siteId"), localStorage.getItem("info"), id).then((res) => {
                    if (res.code == 200) {
                        console.log(res.data)
                        this.recordList = res.data;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },


            tabsChange(i) {
                this.active = i;
            },
            tabsChange2(active, id) {
                this.active2 = id;
                if (active == 0) {
                    this.listData = []
                    this.listData1 = []
                    this.listData2 = []
                    courseExercises(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), 3, id).then((res) => {
                        res.data.forEach((item) => {
                            item.flag = false;
                            item.recordList = [];
                        });
                        this.listData = res.data;
                    });
                } else if (active == 1) {
                    this.listData = []
                    this.listData1 = []
                    this.listData2 = []
                    courseExercises(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), 1, id).then((res) => {
                        console.log(res.data)
                        this.listData1 = res.data;
                    });
                } else {
                    this.listData = []
                    this.listData1 = []
                    this.listData2 = []
                    courseExercises(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), -1, id).then((res) => {
                        this.listData2 = res.data;
                    });
                    /* makeExams(localStorage.getItem("siteId"), localStorage.getItem("info"), id).then((res) => {
                         console.log(res, "做题记录")
                         if (res.code == 200) {
                             this.exercise = res.data.record;
                         } else {
                             this.$message.error(res.msg);
                         }
                     });*/
                }


            },
        },
    };
</script>
